import { AccountCircle } from "@mui/icons-material";
import LogoutIcon from "@mui/icons-material/Logout";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { AppBar, Avatar, Box, Chip, Divider, IconButton, ListItemIcon, Menu, MenuItem, Toolbar, Tooltip, Typography } from "@mui/material";
import React, { FunctionComponent, useState } from "react";
import { CommonConstants } from "../constants/common-constants";
import { useNavigate } from "react-router-dom";
import { TokenUserHelper } from "../services/token-user-service";
import { UIConfigurationContext } from "../contexts/ui-configurationContext";

interface TopNavProps {
  onHelpClick?: () => void;
}

export const TopNav: FunctionComponent<TopNavProps> = ({ onHelpClick }) => {

  const uiConfigData = React.useContext(UIConfigurationContext);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const tokenUser = TokenUserHelper.Get();

  const handleSignOut = () => {
    TokenUserHelper.Delete();
    sessionStorage.removeItem("welcomed");
    navigate(CommonConstants.Routes.Login);
  }

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const navigate = useNavigate();
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            <img
              src={uiConfigData.logoConfiguration.logoURL}
              alt={uiConfigData.logoConfiguration.altText}
              style={uiConfigData.logoConfiguration.logoStyle}
            />

          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {/* {onHelpClick && tokenUser?.UserType !== CommonConstants.UserType.Admin && (
              <Tooltip title="Help">
                <IconButton color="inherit" onClick={onHelpClick} size="small">
                  <HelpOutlineIcon />
                </IconButton>
              </Tooltip>
            )} */}
            {tokenUser && (
              <Chip
                label={tokenUser.UserType === CommonConstants.UserType.Admin ? 'Admin' : 'School'}
                size="small"
                sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'inherit' }}
              />
            )}
            <IconButton onClick={handleMenu} color="inherit" size="small" sx={{ p: 0.5 }}>
              <Avatar sx={{ width: 32, height: 32, bgcolor: 'rgba(255,255,255,0.25)', color: 'inherit', fontSize: '0.875rem', fontWeight: 700 }}>
                {tokenUser?.UserName?.charAt(0).toUpperCase() ?? <AccountCircle />}
              </Avatar>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              PaperProps={{
                elevation: 3,
                sx: {
                  mt: 0.75,
                  minWidth: 200,
                  borderRadius: 2,
                  overflow: 'visible',
                  '&::before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                    borderTop: '1px solid',
                    borderLeft: '1px solid',
                    borderColor: 'divider',
                  },
                },
              }}
            >
              {/* User identity block */}
              <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                  {tokenUser?.UserType !== CommonConstants.UserType.Admin && tokenUser?.SchoolName
                    ? tokenUser.SchoolName
                    : tokenUser?.UserName ?? ''}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {tokenUser?.UserType === CommonConstants.UserType.Admin ? 'Administrator' : tokenUser?.UserName ?? 'School Account'}
                </Typography>
              </Box>
              <Divider />
              <MenuItem onClick={handleSignOut} sx={{ py: 1.25, mt: 0.5, color: 'error.main' }}>
                <ListItemIcon sx={{ color: 'error.main', minWidth: 32 }}>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Sign Out
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
    </>);
}